import { useState } from "react";
import { useForm } from "react-hook-form";
import { useSwipeable } from 'react-swipeable';

import { REOPEN_ID } from "./constants";
import useReopenIncident from "./hooks/useReopenIncident";
import { TFormValues } from "./types";

import Box from "../../Global/Atomics/Box";
import { Button } from "../../Global/Atomics/Button";
import { Heading } from "../../Global/Atomics/Heading";
import { Modal } from "../../Global/Atomics/Modal";
import TextArea from "../../Global/Atomics/TextArea";
import FeedbackPage from "../../Global/Widgets/Feedbacks/FeedbackPage";

import { useTranslationContext } from "../../../contexts/TranslationContext";
import lockScrollbar from "../../../utils/helpers/lockScrollbar";

type TProps = {
    showModal: boolean;
    setShowModal: (value: boolean | ((prevVar: boolean) => boolean)) => void;
}

const ReopenModal = ({ showModal, setShowModal }: TProps) => {
    const [showFeedbackModal, setShowFeedbackModal] = useState(false);
    const { resources } = useTranslationContext();
    
    // Close Modal using useSwippeable
    let handlers = useSwipeable({
        delta: 30,
        onSwipedDown: () => setShowModal(false),
    });
    
    // Handle form (teaxtarea)
    const { register, getValues, formState: { errors, isValid } } = useForm<TFormValues>({
        mode: 'onChange',
        defaultValues: {
            [REOPEN_ID]: '',
        }
    });

    // API call to reopen incident
    const { isLoading, isError, isSuccess, refetch } = useReopenIncident({ setShowFeedbackModal, getValues });

    // Display Feedback modal
    if (showFeedbackModal || isLoading) {
        return (
            <FeedbackPage
                isError={isError}
                isSuccess={isSuccess}
                isLoading={isLoading}
                successTitle={resources.feedback.report.successTitleReopen}
                onErrorCTA={() => { setShowFeedbackModal(false); lockScrollbar(false) }}
            />
        )
    }

    return (
        <Modal dynamic show={showModal} onClose={() => setShowModal(false)}>
            <Box my="lg" mx="md" px="xs" {...handlers}>
                {/* TITLE */}
                <Box mb="lg" >
                    <Heading level={1} typography="text-s-bold">{resources.label.reopenIncident}</Heading>
                </Box>

                {/* TEXTAREA */}
                <Box mb="lg">
                    <TextArea
                        id={REOPEN_ID}
                        rows={5}
                        maxLength={250}
                        required
                        label={resources.form.reopenIncident.label}
                        placeholder={resources.form.reopenIncident.placeholder}
                        errors={errors}
                        register={register(REOPEN_ID, {
                            required: resources.form.reopenIncident.validate.required,
                        })}
                    />
                </Box>

                {/* CTA */}
                <Box display="flex" justifyContent="center" mb="xl">
                    <Button size="s" variant="primary-black" disabled={!isValid} onClick={() => refetch()}>{resources.label.leaveComment}</Button>
                </Box>
            </Box>
        </Modal>
    )
}

export default ReopenModal